// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__nn-EP","spin":"Loader_spin__WCpJ7","Loader_transparent":"Loader_Loader_transparent__+cF2J"};